<template>
  <job-template>
    <template slot="top-section">
      <div>
        <JobseekerFilters />
      </div>
    </template>
    <template slot="content-area">
      <div style="position: relative">
        <main class="content-wrapper">

          <sidebar-modal :active.sync="isSidebarActive" title="Filter"
                         button="Apply filter" clear="Clear filter"
                         :loading="sidebarLoading" v-on:action="apply" v-on:clear="clearFilter">
            <filter-form />
          </sidebar-modal>
          <div class="flexcolumns">
            <margin-title title="" :subtitle="this.$t('nav.jobseekers')" />
            <button  v-if="showFilterbutton"  class="button is-primary" @click="showFilter">
              {{ filterButton }}
            </button>
          </div>
          <jobseeker-list-nav :active.sync="activeItem"
                              :keyword.sync="keyword"
                              :tabItems="['all']"
                              :selectedItem="location"
                              :selectItems="[]"
                              v-on:enter="onEnterPressed" />

          <heading v-if="false">{{ activeItem }} {{this.$t('nav.jobseekers')}}</heading>
          <jobs-skeleton  v-if="jobSeekerLoading"></jobs-skeleton>
          <jobseekers-list v-else />
        </main>
      </div>

    </template>
  </job-template>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import MarginTitle from '@/components/margin-title'
import ListNav from '@/components/general/list-nav'
import JobseekersList from '@/components/jobseekers/jobseekers-list'
import Heading from '@/components/general/heading'
import JobseekerFilters from '../components/jobseekers/jobseeker-filters'
import FilterForm from '@/components/jobseekers/jobseeker-filter-form'
import SidebarModal from '@/components/sidebar-modal'
import JobseekerAutocompleteFilter from '@/components/jobseekers/jobseeker-autocomplete-filter'
import JobseekerListNav from '../components/jobseekers/jobseeker-list-nav'
import RowSkeleton from '@/components/general/row-skeleton'
import JobsSkeleton from '../components/jobs/jobs-skeleton'
import JobTemplate from '../templates/job-template'

export default {
  components: {
    JobTemplate,
    MarginTitle,
    ListNav,
    JobseekersList,
    Heading,
    SidebarModal,
    FilterForm,
    JobseekerAutocompleteFilter,
    JobseekerListNav,
    RowSkeleton,
    JobsSkeleton,
    JobseekerFilters
  },
  data () {
    return {
      activeItem: 'all',
      showSidebar: false,
      isSidebarActive: false,
      sidebarLoading: false,
      timer: null,
      showFilterbutton: false
    }
  },
  computed: {
    ...mapState('jobseekers', {
      jobseekers: 'jobseekers',
      jobseekerKeyword: 'keyword',
      jobseekerLocation: 'location',
      jobSeekerLoading: 'jobSeekerLoading'
    }),
    ...mapGetters('jobseekers', [
      'filterCount'
    ]),
    keyword: {
      get () { return this.jobseekerKeyword },
      set (value) {
        this.setKeyword(value)

        if (value === '') { return this.onEnterPressed() }
        window.clearTimeout(this.timer)

        this.timer = window.setTimeout(() => {
          this.updateJobseekers()
        }, 500)
      }
    },
    location: {
      get () { return this.jobseekerLocation || 'Anywhere' },
      set (value) { this.setLocation(value) }
    },
    filterButton () {
      const count = this.filterCount
      return count === 0 ? `FILTER` : `FILTER (${count})`
    }
  },
  methods: {
    ...mapMutations('jobseekers', [
      'setKeyword',
      'setLocation'
    ]),
    ...mapActions('jobseekers', [
      'listJobseekers',
      'searchJobseekers',
      'applyFilter',
      'clearFilter'
    ]),
    ...mapActions('jobs', ['getJobSeekersBoardList']),
    onEnterPressed () {
      window.clearTimeout(this.timer)
      this.updateJobseekers()
    },
    updateJobseekers () {
      this.listJobseekers()
    },
    showFilter () {
      this.isSidebarActive = true
    },
    async apply () {
      this.sidebarLoading = true
      try {
        await this.applyFilter()
        this.isSidebarActive = false
      } catch (error) {
      }
      this.sidebarLoading = false
    }
  },
  mounted () {
    this.updateJobseekers()
    this.getJobSeekersBoardList()
  }
}
</script>

<style lang="scss" scoped>
.flexcolumns {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
.button.is-primary {
  min-width: 96px;
  min-height: 40px;
  padding: 0 1.8rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/jobseekers.vue